import React from 'react';

const CoachingTrackSkeleton = () => {
  return (
    <div className="animate-pulse bg-slate-900 p-6 rounded-lg border border-slate-700">
      {/* Header Placeholder */}
      <div className="flex justify-between items-center mb-8">
        <div>
          <div className="h-8 bg-slate-700 rounded w-64 mb-2"></div>
          <div className="h-5 bg-slate-700 rounded w-48"></div>
        </div>
      </div>

      {/* Stats Cards Placeholder */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="bg-slate-800 rounded-xl p-6 border border-slate-700">
            <div className="flex items-center justify-between">
              <div>
                <div className="h-4 bg-slate-700 rounded w-24 mb-2"></div>
                <div className="h-8 bg-slate-700 rounded w-16"></div>
              </div>
              <div className="w-12 h-12 bg-slate-700 rounded-lg"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Search and Filters Placeholder */}
      <div className="bg-slate-800 rounded-xl p-6 mb-6 border border-slate-700">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="relative flex-1">
            <div className="h-10 bg-slate-700 rounded-lg w-full"></div>
          </div>
          <div className="flex gap-2">
            <div className="h-10 bg-slate-700 rounded-lg w-32"></div>
          </div>
        </div>
      </div>

      {/* Students List Placeholder */}
      <div className="space-y-4">
        {[...Array(3)].map((_, i) => ( // Show 3 placeholder student cards
          <div key={i} className="bg-slate-800 rounded-xl p-6 border border-slate-700">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-slate-700 rounded-full"></div>
                <div>
                  <div className="h-6 bg-slate-700 rounded w-48 mb-2"></div>
                  <div className="h-4 bg-slate-700 rounded w-32"></div>
                  <div className="flex gap-2 mt-1">
                    <div className="h-5 bg-slate-700 rounded w-20"></div>
                    <div className="h-5 bg-slate-700 rounded w-20"></div>
                    <div className="h-5 bg-slate-700 rounded w-16"></div>
                  </div>
                </div>
              </div>
              <div className="flex items-center space-x-8">
                <div className="text-center">
                  <div className="h-8 bg-slate-700 rounded w-12 mb-1"></div>
                  <div className="h-4 bg-slate-700 rounded w-16"></div>
                </div>
                <div className="text-center">
                  <div className="h-8 bg-slate-700 rounded w-12 mb-1"></div>
                  <div className="h-4 bg-slate-700 rounded w-16"></div>
                </div>
                <div className="text-center">
                  <div className="h-8 bg-slate-700 rounded w-12 mb-1"></div>
                  <div className="h-4 bg-slate-700 rounded w-16"></div>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="h-10 bg-slate-700 rounded-lg w-28"></div>
                  <div className="h-9 w-9 bg-slate-700 rounded-lg"></div>
                  <div className="h-9 w-9 bg-slate-700 rounded-lg"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoachingTrackSkeleton;
